import { z } from "zod";
import { WeeklyAvailabilitySchema } from "./availability";
import { cognitoUuid } from "./validation-common";

export const WorkHistoryItemSchema = z.object({
  employer: z.string(),
  role: z.string(),
  startYear: z.number().int(),
  endYear: z.number().int().optional(),
  isCurrent: z.boolean(),
});

export type WorkHistoryItem = z.infer<typeof WorkHistoryItemSchema>;

export const CandidateProfileSchema = z.object({
  candidateId: cognitoUuid,
  email: z.string().email(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  photoMediaId: z.uuid().optional(),
  address: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  idFrontMediaId: z.uuid().optional(),
  idBackMediaId: z.uuid().optional(),
  idCapturedAt: z.string().optional(),
  preferredRoles: z.array(z.string()).optional(),
  preferredLocations: z.array(z.string()).optional(),
  certifications: z.array(z.string()).optional(),
  availability: WeeklyAvailabilitySchema.optional(),
  workHistory: z.array(WorkHistoryItemSchema).optional(),
  profileComplete: z.boolean(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type CandidateProfile = z.infer<typeof CandidateProfileSchema>;

export const UpdateProfileSchema = CandidateProfileSchema
  .omit({ candidateId: true, email: true, profileComplete: true, createdAt: true, updatedAt: true })
  .partial();

export type UpdateProfile = z.infer<typeof UpdateProfileSchema>;

export const UpdateProfileResponseSchema = z.object({
  message: z.string(),
  candidateId: z.string(),
  profileComplete: z.boolean(),
});

export type UpdateProfileResponse = z.infer<typeof UpdateProfileResponseSchema>;
